import type { RouterOnChangeArgs } from 'preact-router'
import { Router } from 'preact-router'
import '../styles/global.css'
import '../styles/nodes.css'
import { Analytics } from './Analytics.js'
import { Header } from './components/index.js'
// ULICRAFT FORK — Changelog, Versions, WhatsNew and Sounds are not imported.
// See the route list below for why each one is gone.
import { Convert, Customized, Generator, Generators, Guide, Guides, Home, LegacyPartners, Partners, Transformation, Worldgen } from './pages/index.js'
import { cleanUrl } from './Utils.js'

export function App() {
	const changeRoute = (e: RouterOnChangeArgs) => {
		window.dispatchEvent(new CustomEvent('replacestate'))
		// Needs a timeout to ensure the title is set correctly
		setTimeout(() => Analytics.pageview(cleanUrl(e.url)))
	}

	return <>
		<Header />
		<Router onChange={changeRoute}>
			<Home path="/" />
			<Generators path="/generators" />
			<Worldgen path="/worldgen" />
			<Partners path="/partners" />
			<LegacyPartners path="/partners/:id" />
			{/* ULICRAFT FORK — four routes removed, all for the same reason:
			    they depend on data we cannot serve from our own origin, and at
			    the party there is no internet.

			    /sounds     — needs the .ogg files from the full mcmeta assets
			                  tag (hundreds of MB). We mirror assets-tiny
			                  instead, so playback would 404 on every sound.
			    /changelog  — misode/technical-changes, not mirrored.
			    /versions   — mcmeta-diff.misode.workers.dev, a server-side API.
			    /whats-new  — whats-new.misode.workers.dev, likewise.

			    Removing the routes (not just the nav links) is deliberate: a
			    page that loads and then hangs forever is worse than a 404, and
			    at the venue nobody can tell the difference between "broken" and
			    "still loading". */}
			<Transformation path="/transformation" />
			<Customized path="/customized" />
			<Convert path="/convert" />
			<Convert path="/convert/:formats" />
			<Guides path="/guides" />
			<Guide path="/guides/:id" />
			<Generator default />
		</Router>
	</>
}
